import getDayName from '../get-day-name';
import isToday from '../is-today';
import isTomorrow from '../is-tomorrow';
import isYesterday from '../is-yesterday';

export const getDateValue = (date: Date) => {
  if (isToday(date)) {
    return 'I dag';
  }

  if (isYesterday(date)) {
    return 'I går';
  }

  if (isTomorrow(date)) {
    return 'I morgen';
  }

  return getDayName(date, { titleCase: true });
};

export default getDateValue;
